import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DailyReportService {
  constructor(private http: HttpClient) {}

  getAll(date: any) {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/reports/daily-report?date=${date}`
    );
  }

  exportToPdf(date: any) {
    return this.http
      .get<any>(
        `${environment.apiUrl}/api/reports/pdf/daily-report?date=${date}`
      )
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }
}
